export default "__VITE_ASSET__zISQ0k1m__"